import { mapGenericBusinessTypeFromNativeBusinessType } from '../../../utils/country/NO/data-helpers';
export const NO_businessTypeFunction = (data) => {
    const businessType = mapGenericBusinessTypeFromNativeBusinessType(data.nativeBusinessType);
    return Object.assign(Object.assign({}, data), { businessType });
};
